import React from 'react'
import join from '../utils'
import Typography from '../Typography'

const Home = () => {
  return (
    <section className={join('mb-10 md:mt-20 md:px-20 px-5', 'font-Changa ')}>
      <Typography
        variant='h1'
        className='text-text'
      >
        Spring Cleaning Is Here!
      </Typography>
      <hr className='my-2 mx-[30vw] h-2' />
      <Typography
        variant='h4'
        className='text-secondary font-bold drop-shadow-xlg '
      >
        Get your home ready for summer with our limited-time deals!
        <br />
        Driveway and Walkway combo starting at $249
        <br />
        Garbage Can Sanitization starting at $25
      </Typography>
    </section>
  )
}
export default Home
